<template>
  <div
    class="process"
    v-if="process.length > 0"
  >
    <div
      class="gp"
      v-for="(item, i) in process"
      :key="i"
    >
      <div class="box">
        <img :src="item.image_url">
      </div>
      <p>{{item.image_name}}</p>
    </div>
  </div>
</template>
        
  <script>
export default {
  name: "process",
  props: ["groupInfo"],
  data: function () {
    return {
      process: "",
    };
  },
  methods: {
    // 获取活动奖励
    getImage(id) {
      let data = {
        tm: Date.parse(new Date()),
        papp_id: id,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getImage,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.process = res.data.data.gift_img_info;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    // 拿到团队信息后请求奖励
    groupInfo: function () {
      this.getImage(this.groupInfo.papp_id);
    },
  },
};
</script>
        
<style scoped lang="scss">
.process {
  display: flex;
  align-items: flex-start;
  margin: 0.25rem 0;
  justify-content: space-between;
  .gp {
    width: 1.5rem;
    .box {
      width: 1.35rem;
      height: 1.35rem;
      border: 1px solid #d2d2d2;
      background: #f2f2f2;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.1rem;
      img {
        width: 100%;
      }
    }
    p {
      font-size: 0.21rem;
      color: #969696;
      text-align: center;
      line-height: 0.5rem;
      margin: 0;
    }
  }
  .plan {
    width: 1.2rem;
    height: 0.12rem;
    border: 1px solid #d2d2d2;
    background: #f2f2f2;
    margin-bottom: 0.4rem;
    &.on {
      border: 1px solid #ff5750;
      background: #ff5750;
    }
  }
}
</style>